// extracted by mini-css-extract-plugin
export default {"scrollTable":"ConversionManagerTable_scrollTable__p3op6"};